"use strict";

var _objectWithoutProperties = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("@material-ui/core/styles");

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var useStyles = styles_1.makeStyles(function (theme) {
  return styles_1.createStyles({
    button: {
      margin: theme.spacing(1),
      padding: '.8rem 1rem',
      fontWeight: theme.typography.fontWeightBold
    }
  });
});

var CustomModalButton = function CustomModalButton(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["onClick", "children"]);

  var classes = useStyles();
  return react_1.default.createElement(Button_1.default, Object.assign({
    variant: "contained",
    color: "primary",
    className: classes.button,
    onClick: onClick
  }, otherProps), children);
};

exports.default = CustomModalButton;